import React from "react";
var __jsx = React.createElement;
import stl from "./MakeCars.module.css";
import { Link } from "react-router-dom";
import useHelpers from "@hooks/useHelpers";
import { useTranslation } from "@i18n";
var MakeCars = function MakeCars(_ref) {
  var makes = _ref.makes,
    cityName = _ref.cityName;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.MCC_container
  }, /*#__PURE__*/React.createElement("h2", null, t("سيارات للبيع في {{cityName}} حسب الماركة", {
    ns: "web_city",
    cityName: cityName
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.MCC_makesContainer
  }, makes.map(function (make, idx) {
    return /*#__PURE__*/React.createElement(Link, {
      key: idx,
      className: "".concat(stl.anchorDesign, " ").concat(idx == 8 && "m-show"),
      to: createUrl("/autos/".concat(make.name_seo))
    }, /*#__PURE__*/React.createElement("div", {
      className: stl.imgContainer
    }, /*#__PURE__*/React.createElement("img", {
      src: make.icon,
      alt: make.name,
      width: 90,
      height: 90,
      loading: "lazy"
    })), /*#__PURE__*/React.createElement("p", null, make.name));
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.buttonContainer
  }, /*#__PURE__*/React.createElement(Link, {
    to: createUrl("/autos"),
    className: ["whtBtn", stl.button].join(" ")
  }, t("شاهد جميع الماركات", {
    ns: "web_city"
  })))));
};
export default MakeCars;